import './TextbookNotebook.css';

import {
	Box,
	Breadcrumbs,
	Button,
	Card,
	CardContent,
	CardMedia,
	Chip,
	Tooltip,
	Typography,
} from '@mui/material';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { getEmbedUrl } from '../../../../hooks/getEmbededYoutubeLink';
import { setNotebook } from '../../../../store/notebookSlice';
import { subtopicContent } from '../../../../constants/constants';

const TextbookNotebook = ({ handleSubTopicClickInternal }) => {
	const { selectedSubTopicData, topiclist } = useSelector((state) => state.selectedSubTopic);

	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const { topicName, subtopicName, topicId, subtopicId } = selectedSubTopicData;

	const contentData = subtopicContent[subtopicId] || {};

	const videos = [
		'https://youtu.be/IqMaKCdP-M8',
		'https://youtu.be/IqMaKCdP-M8',
		'https://youtu.be/IqMaKCdP-M8',
	];

	// const topicList = [
	// 	{
	// 		SUBTOPIC_NAME: 'Linear equations in one variable',
	// 		SUBTOPIC_PROGRESS: 0,
	// 		SUBTOPIC_ID: '2072cca6-82e1-4e0f-9d14-25a9ff4465c1',
	// 	},
	// 	{
	// 		SUBTOPIC_NAME: 'Linear equations in two variables',
	// 		SUBTOPIC_PROGRESS: 0,
	// 		SUBTOPIC_ID: '8c0c3f39-4bb1-44c1-b8cf-0850f4584508',
	// 	},
	// 	{
	// 		SUBTOPIC_NAME: 'Linear functions',
	// 		SUBTOPIC_PROGRESS: 0,
	// 		SUBTOPIC_ID: '72dc3277-087d-4202-a9bc-5fa72c29f988',
	// 	},
	// 	{
	// 		SUBTOPIC_NAME: 'Systems of two linear equations in two variables',
	// 		SUBTOPIC_PROGRESS: 0,
	// 		SUBTOPIC_ID: '60833cfc-8d81-43a0-bd45-0f68358c2822',
	// 	},
	// 	{
	// 		SUBTOPIC_NAME: 'Linear inequalities in one or two variables',
	// 		SUBTOPIC_PROGRESS: 0,
	// 		SUBTOPIC_ID: 'e32ab858-4277-4ae8-b61e-0f3ceb4c057f',
	// 	},
	// ];

	const config = {
		loader: { load: ['[tex]/ams'] },
		tex: {
			packages: { '[+]': ['ams'] }, // enable ams
		},
	};
	const content = `A quadratic function is given as:
\\[
f(x) = x^2 - 6x + 8
\\]

For what value(s) of \\(x\\) does \\(f(x) = 0\\)?

\\[
\\begin{array}{@{}rl@{}}
\\textbf{A)} & 2 \\text{ and } 4 \\\\
\\textbf{B)} & -2 \\text{ and } -4 \\\\
\\textbf{C)} & 3 \\text{ and } -3 \\\\
\\textbf{D)} & 6 \\text{ and } -8
\\end{array}
\\]`;

	const content2 = `To find the values of \\( x \\) for which \\( f(x) = 0 \\), we set the equation equal to zero:

\\[
x^2 - 6x + 8 = 0
\\]

\ Step 1: Factor the Quadratic Expression \

\ We can factor it by finding two numbers that multiply to \\(8\\) and sum to \\(-6\\).
Those numbers are \\(-2\\) and \\(-4\\), so:\

\\[
(x - 2)(x - 4) = 0
\\]

Step 2: Solve for \\( x \\) \

Setting each factor equal to zero:

\\[
x - 2 = 0 \\quad \\Rightarrow \\quad x = 2
\\]

\\[
x - 4 = 0 \\quad \\Rightarrow \\quad x = 4
\\]

Thus, the solutions are \\( x = 2 \\) and \\( x = 4 \\).
`;
	return (
		<>
			{' '}
			{isLoading ? (
				<loader />
			) : (
				<>
					<div className="breadcrumb-container">
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" sx={{ margin: '0' }} />}
							aria-label="breadcrumb"
						>
							<Chip
								label="KC"
								sx={{
									backgroundColor: '#001ffe',
									color: '#fff',
									borderColor: '#fff',
								}}
							/>
							<Chip
								label={topicName}
								sx={{
									backgroundColor: '#001ffe',
									color: '#fff',
									borderColor: '#fff',
								}}
							/>
							{/* <Chip
						label={subtopicName}
						sx={{ backgroundColor: '#001ffe', color: '#fff', borderColor: '#fff' }}
					/> */}
						</Breadcrumbs>
					</div>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: { xs: 'column', sm: 'row' },
							paddingX: '1.25rem',
							width: '100%',
						}}
					>
						<Box sx={{ width: { xs: '100%', sm: '70%' } }}>
							<Box
								sx={{
									width: '100%',
									display: 'flex',
									justifyContent: 'start',
									marginBottom: '0.75rem',
								}}
							>
								<Button
									variant="contained"
									sx={{
										background:
											'linear-gradient(90deg, #2253F6 0%, #143190 100%)',
										color: '#fff !important',
									}}
									disabled
								>
									{subtopicName}
								</Button>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
									borderRadius: '6px',
									background: '#FFF',
									boxShadow: '0px 4px 30px 4px rgba(0, 0, 0, 0.25)',
									marginBottom: '2rem',
									padding: '1rem',
									textAlign: 'left',
								}}
							>
								<Typography variant="h6" gutterBottom sx={{ fontWeight: 'Bold' }}>
									Breif Introduction
								</Typography>
								<Typography
									variant="body1"
									gutterBottom
									sx={{ mb: '2.5rem', whiteSpace: 'pre-line' }}
								>
									{/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
									eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
									enim ad minim veniam, quis nostrud exercitation ullamco laboris
									nisi ut aliquip ex ea commodo consequat. */}
									{contentData?.introduction}
								</Typography>
								<Typography variant="h6" gutterBottom sx={{ fontWeight: 'Bold' }}>
									Detailed Information
								</Typography>
								<Typography
									variant="body1"
									gutterBottom
									sx={{ mb: '2rem', whiteSpace: 'pre-line' }}
								>
									{/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
									eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
									enim ad minim veniam, quis nostrud exercitation ullamco laboris
									nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
									in reprehenderit in voluptate velit esse cillum dolore eu fugiat
									nulla pariatur. Excepteur sint occaecat cupidatat non proident,
									sunt in culpa qui officia deserunt mollit anim id est
									laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit,
									sed do eiusmod tempor incididunt ut labore et dolore magna
									aliqua. Ut enim ad minim veniam, quis nostrud exercitation
									ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem
									ipsum dolor sit amet, consectetur adipiscing elit, sed do
									eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
									enim ad minim veniam, quis nostrud exercitation ullamco laboris
									nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
									in reprehenderit in voluptate velit esse cillum dolore eu fugiat
									nulla pariatur. Excepteur sint occaecat cupidatat non proident,
									sunt in culpa qui officia deserunt mollit anim id est
									laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit,
									sed do eiusmod tempor incididunt ut labore et dolore magna
									aliqua. Ut enim ad minim veniam, quis nostrud exercitation
									ullamco laboris nisi ut aliquip ex ea commodo consequat.
									Excepteur sint occaecat cupidatat non proident, sunt in culpa
									qui officia deserunt mollit anim id est laborum.Lorem ipsum
									dolor sit amet, consectetur adipiscing elit, sed do eiusmod
									tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
									minim veniam, quis nostrud exercitation ullamco laboris nisi ut
									aliquip ex ea commodo consequat. */}
									{contentData?.details}
								</Typography>
								{/* <Typography variant="h6" gutterBottom sx={{ fontWeight: 'Bold' }}>
									Images and Diagram
								</Typography>
								<Box className="ImageContainer" sx={{ mb: '2rem' }}></Box> */}
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
									borderRadius: '6px',
									background: '#FFF',
									boxShadow: '0px 4px 30px 4px rgba(0, 0, 0, 0.25)',
									marginBottom: '2rem',
									padding: '1rem 1rem 2rem 1rem',
									textAlign: 'left',
								}}
							>
								<MathJaxContext config={config}>
									<Typography
										variant="h6"
										gutterBottom
										sx={{ fontWeight: 'Bold' }}
									>
										Questions and Examples
									</Typography>
									<Box sx={{ mb: '2.5rem' }}>
										{contentData.examples?.map((ex, idx) => (
											<MathJax key={idx}>
												<Typography variant="h6" gutterBottom>
													{idx + 1}. Question:
												</Typography>
												{ex?.sentence && (
													<Typography variant="body1" sx={{ ml: '1rem' }}>
														<strong>Sentence:</strong> <br />
														{ex.sentence}
													</Typography>
												)}
												{ex?.passage && (
													<Typography variant="body1" sx={{ ml: '1rem' }}>
														<strong>passage:</strong> <br />
														{ex.passage}
													</Typography>
												)}
												{ex?.text1 && (
													<Typography variant="body1" sx={{ ml: '1rem' }}>
														<strong>text1:</strong> <br />
														{ex.text1}
													</Typography>
												)}
												{ex?.text2 && (
													<Typography variant="body1" sx={{ ml: '1rem' }}>
														<strong>text2:</strong> <br />
														{ex.text2}
													</Typography>
												)}
												<Typography variant="body2" sx={{ ml: '1rem' }}>
													<strong>
														Question: <br />
														{ex.question}
													</strong>
												</Typography>
												<ol
													style={{
														listStyleType: 'none',
														paddingLeft: '2rem',
													}}
												>
													{ex.options.map((opt, i) => (
														<li key={i}>
															{String.fromCharCode(65 + i)}) {opt}
														</li>
													))}
												</ol>
												<Typography variant="body2" sx={{ ml: '1rem' }}>
													<strong>Answer:</strong> <br />
													{ex.answer}
												</Typography>
												<Typography
													variant="body2"
													sx={{ mb: '2rem', ml: '1rem' }}
												>
													<strong>Explanation:</strong> <br />
													{ex.explanation}
												</Typography>
											</MathJax>
										))}
									</Box>
									{/* <Typography
										variant="h6"
										gutterBottom
										sx={{ fontWeight: 'Bold' }}
									>
										Solution & Explanation:
									</Typography>
									<Box>
										<MathJax>{content2}</MathJax>
									</Box> */}
								</MathJaxContext>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
									borderRadius: '6px',
									boxShadow: '0px 4px 30px 4px rgba(0, 0, 0, 0.25)',
									marginBottom: '2rem',
									padding: '1rem 1rem 2rem 1rem',
									textAlign: 'left',
									background: 'linear-gradient(90deg, #2253F6 0%, #143190 100%)',
									color: '#fff',
								}}
							>
								<Typography variant="h6" gutterBottom sx={{ fontWeight: 'Bold' }}>
									Key Point/Summary/Takeaways
								</Typography>
								<Typography variant="body1" gutterBottom>
									{/* Excepteur sint occaecat cupidatat non proident, sunt in culpa
									qui officia deserunt mollit anim id est laborum.Lorem ipsum
									dolor sit amet, consectetur adipiscing elit, sed do eiusmod
									tempor incididunt ut labore et dolore magna aliqua. */}
									{contentData?.takeaways?.map((takeaway, index) => (
										<Typography
											key={index}
											variant="body1"
											gutterBottom
											component={'ul'}
										>
											<li>{takeaway}</li>
										</Typography>
									))}
								</Typography>
							</Box>
						</Box>
						<Box sx={{ width: { xs: '100%', sm: '28%' } }}>
							<Box
								sx={{
									width: '100%',
									display: 'flex',
									justifyContent: 'start',
									marginBottom: '0.75rem',
									minHeight: '2.25rem',
									maxHeight: 'fit-content',
								}}
							>
								<Typography
									variant="button"
									// gutterBottom
									sx={{ fontWeight: 'Bold', textAlign: 'left' }}
								>
									Related Video Lectures
								</Typography>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
									borderRadius: '6px',
									background: '#FFF',
									boxShadow: '0px 4px 30px 4px rgba(0, 0, 0, 0.25)',
									marginBottom: '2rem',
									padding: '1rem',
									textAlign: 'left',
								}}
							>
								{videos.map((video, index) => {
									return (
										<Box sx={{ width: '100%', mb: '1rem' }}>
											<Card sx={{ maxWidth: 600, margin: 'auto', mt: 4 }}>
												<div
													style={{
														position: 'relative',
														paddingTop: '56.25%' /* 16:9 ratio */,
													}}
												>
													<iframe
														src={getEmbedUrl(video)}
														title="YouTube video"
														allowFullScreen
														style={{
															position: 'absolute',
															top: 0,
															left: 0,
															width: '100%',
															height: '100%',
															border: 0,
														}}
													/>
												</div>
											</Card>
										</Box>
									);
								})}
								<Box sx={{ width: '100%', mb: '1rem' }}>
									<Box
										// sx={{
										// 	width: '100%',
										// 	backgroundColor: '#08BD80',
										// 	borderTopLeftRadius: 6,
										// 	borderTopRightRadius: 6,
										// 	border: '1px #545454 solid',
										// 	textAlign: 'center',
										// }}
										className="TBtopicList"
									>
										<Typography
											variant="h6"
											gutterBottom
											sx={{
												fontWeight: 'Bold',
												color: '#fff',
											}}
										>
											Relevant Subtopics
										</Typography>
									</Box>
									{topiclist?.[topicId]?.subtopics?.map((topic, index) => {
										if (topic.SUBTOPIC_ID !== subtopicId) {
											return (
												<Box
													className="TBtopicList"
													onClick={() => {
														handleSubTopicClickInternal(
															topicId,
															topic.SUBTOPIC_ID,
															setIsLoading
														);
													}}
												>
													<Tooltip
														title={topic.SUBTOPIC_NAME}
														placement="top"
														followCursor
													>
														<Typography
															variant="h6"
															gutterBottom
															sx={{
																fontWeight: 'Bold',
																color: '#fff',
																whiteSpace: 'nowrap',
																overflow: 'hidden',
																textOverflow: 'ellipsis',
															}}
														>
															{topic.SUBTOPIC_NAME}
														</Typography>
													</Tooltip>
												</Box>
											);
										}
									})}
								</Box>
							</Box>
						</Box>
					</Box>
					{/* <Box sx={{ width: '100%', padding: '1.25rem', textAlign: 'left' }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: 'Bold' }}>
							Recommended Resources
						</Typography>
						<ul>
							<li>
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
								officia deserunt mollit anim id est laborum
							</li>
							<li>
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
								officia deserunt mollit anim id est laborum
							</li>
							<li>
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
								officia deserunt mollit anim id est laborum
							</li>
							<li>
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
								officia deserunt mollit anim id est laborum
							</li>
						</ul>
					</Box> */}
				</>
			)}
		</>
	);
};

export default TextbookNotebook;
